import { useQuery } from '@mint-lib/query-client';
import { useService } from '@mint-lib/routing-context';
import { AdFormIntegrations } from '@mint-sdk/api-integrations';

export const useGetAdFormIntegrations = ({ enabled }: { enabled: boolean }) => {
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isLoading } = useQuery(
    {
      ...AdFormIntegrations.getQueryOptions({}),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled,
    },
    queryClient,
  );

  return {
    data,
    isLoading,
  };
};
